import { State, Module } from "app/decorators.js";

// Admin Control Apps
import HomeRouter from "./home/routing";
import ProjectRouter from "./product/routing";
import ProductConfRouter from "./product_conf/routing";
import UserRouter from "./users/routing";
import HaulerRouter from "./hauler/routing";
import PrinterRouter from "./printers/routing";
import ChemicalProgramRouter from "./chemical_programs/routing";
import InventoryRouter from "./inventory/routing";
import HitPercentageRouter from "./hit_percentages/routing";
import MixCalculatorRouter from "./mix_calculator/routing";

import CompanyPicker from "app/directives/company.picker";

@Module({
  name: "app.admin.routing",
  modules: [
    HomeRouter,
    ProjectRouter,
    ProductConfRouter,
    UserRouter,
    CompanyPicker,
    PrinterRouter,
    ChemicalProgramRouter,
    InventoryRouter,
    HitPercentageRouter,
    MixCalculatorRouter,
  ],
})
@State({
  name: "r.in.top.admin",
  url: "/admin",
  template: "<div ui-view></div>",
  abstract: ".home",
  data: {
    permissions: {
      only: ["main.can_view_admin_panel"],
    },
  },
  ncyBreadcrumb: {
    label: "Admin",
    parent: "r.in.top",
  },
})
export default class States {}



// WEBPACK FOOTER //
// ./src/app/admin/routing.js